import { useEffect } from 'react';

import { PlusSVG } from '@assets/img/icons';
import { LayoutModal } from '@layouts';
import { useAppDispatch } from '@store/';
import { hideModal } from '@store/Modal';
import { createStaffRequest } from '@store/ProjectAdd';
import { UIButton, UIInput } from '@ui';
import { Button } from '@utils/utility-property';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';

import { INITIAL_VALUES } from './constant';
import { validationSchema } from './schema';
import './style.scss';

const WidgetsModalAddStaff = () => {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();

  const handlerSubmit = (values) => {
    dispatch(createStaffRequest(values));
  };

  const form = useFormik({
    enableReinitialize: true,
    initialValues: INITIAL_VALUES,
    validationSchema: validationSchema(),
    onSubmit: handlerSubmit,
  });

  useEffect(() => {
    validationSchema();
  }, [i18n.language]);

  return (
    <LayoutModal title={t('PROJECT.ADD_STAFF')} className="modal__added">
      <form onSubmit={form.handleSubmit}>
        <div className="modal__added__items">
          <UIInput
            label={t('COMMON.NAME')}
            name="first_name"
            value={form.values.first_name}
            className="input"
            placeholder={t('COMMON.NAME')}
            classLabel="fw700"
            onChange={form.handleChange}
            isValid={!(form.errors.first_name && form.touched.first_name)}
            validateText={form.errors.first_name}
          />
          <UIInput
            label={t('COMMON.SURNAME')}
            name="last_name"
            value={form.values.last_name}
            className="input"
            placeholder={t('COMMON.SURNAME')}
            classLabel="fw700"
            onChange={form.handleChange}
            isValid={!(form.errors.last_name && form.touched.last_name)}
            validateText={form.errors.last_name}
          />
          <UIInput
            label={t('COMMON.EMAIL')}
            name="email"
            value={form.values.email}
            className="input"
            placeholder={t('COMMON.EMAIL')}
            classLabel="fw700"
            onChange={form.handleChange}
            isValid={!(form.errors.email && form.touched.email)}
            validateText={form.errors.email}
          />
          <UIInput
            label={t('COMMON.PHONE')}
            name="phone"
            value={form.values.phone}
            className="input"
            placeholder={t('COMMON.PHONE')}
            classLabel="fw700"
            onChange={form.handleChange}
            isValid={!(form.errors.phone && form.touched.phone)}
            validateText={form.errors.phone}
          />

          <div className="added-btn">
            <UIButton type={Button.SUBMIT} className="outline__blue">
              <PlusSVG />
              <span>{t('COMMON.ADD')}</span>
            </UIButton>
            <UIButton
              className="btn__gray"
              handler={() => dispatch(hideModal())}
            >
              {t('COMMON.CANCEL')}
            </UIButton>
          </div>
        </div>
      </form>
    </LayoutModal>
  );
};

export default WidgetsModalAddStaff;
